import { Container, Grid, Box, Typography } from '@mui/material'
import ListaOpcoes from '../../../../utils/listaOpcoes'
import HeaderSession from '../../../../utils/headerSession'

export default function Desalfandegar() {
    return (
        <Container style={{ minHeight: '70vh' }}>
            <Box sx={{ display: { md: 'none' } }}>
                <HeaderSession title='DESALFANDEGAR' />
            </Box>

            <Grid container>
                <Grid margin={1} xs={12} md={5.7} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh' }}>
                    <img src="/icones/Desalfandegar.svg" alt="" width={'50%'} />
                </Grid>
                <Grid margin={1} xs={12} md={5.7} item >

                    <Box width={'100%'} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <HeaderSession title='DESALFANDEGAMENTO' />
                    </Box>

                    <Typography variant='subtitle1' fontSize={22} align="center" m={2} color={"secondary"}>
                        EMISSÃO DE DECLARAÇÃO PARA DESALFANDEGAMENTO
                    </Typography>

                    <ListaOpcoes nomeOpcao='Medicamentos controlados internacionalmente' link='/utente/solicitacao/desalfandegamento-directo/Medicamentos-controlados-internacionalmente' />
                    <ListaOpcoes nomeOpcao='Medicamentos controlados nacionais' link='/utente/solicitacao/desalfandegamento-directo/Medicamentos-controlados-nacionais' />
                    <ListaOpcoes nomeOpcao='Medicamento Normal' link='/utente/solicitacao/desalfandegamento-directo/Medicamento-Normal' />
                    <ListaOpcoes nomeOpcao='Suplemento Alimentar' link='/utente/solicitacao/desalfandegamento-directo/Suplemento-Alimentar' />
                    <ListaOpcoes nomeOpcao='Equipamento' link='/utente/solicitacao/desalfandegamento-directo/Equipamento' />
                    <ListaOpcoes nomeOpcao='Reagentes / TDRs' link='/utente/solicitacao/desalfandegamento-directo/Reagentes-TDRs' />

                    <br />
                    <ListaOpcoes nomeOpcao='Soliçitar número de importador ?' link='/utente/solicitacao/numero-de-importador' />
                </Grid>

            </Grid>
            <br />
        </Container>
    )
}
